module.exports = __webpack_public_path__ + "static/img/map_tianjin.1bb6f45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join/map_tianjin.png
// module id = H96Q
// module chunks = 0